export default (element) => {
  const init = () => {
    const maxHeightTwoLines = 42;
    const maxHeightThreeLines = 62;
    const description = element.querySelector('[data-text]');
    const btns = element.querySelectorAll('[data-action]');

    if (description) {
      const showReadButtons =
        (description.clientHeight > maxHeightTwoLines &&
          window.innerWidth >= 768) ||
        (description.clientHeight > maxHeightThreeLines &&
          window.innerWidth < 768);
      if (showReadButtons) {
        const totalLines = window.innerWidth >= 768 ? 2 : 3;
        const maxHeight =
          totalLines === 2 ? maxHeightTwoLines : maxHeightThreeLines;
        btns.forEach((el) => {
          if (el.dataset.action === 'show') {
            el.classList.toggle('hidden');
            description.classList.add(
              `line-clamp-${totalLines}`,
              `max-h-[${maxHeight}px]`,
              'overflow-hidden',
            );
          }
          el.addEventListener('click', () => {
            btns.forEach((btn) => btn.classList.toggle('hidden'));
            if (el.dataset.action === 'show') {
              description.classList.remove(
                `line-clamp-${totalLines}`,
                `max-h-[${maxHeight}px]`,
                'overflow-hidden',
              );
            } else {
              description.classList.add(
                `line-clamp-${totalLines}`,
                `max-h-[${maxHeight}px]`,
                'overflow-hidden',
              );
            }
          });
        });
      }
    }
  };

  init();
};
